// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Label, required "*", hint and error text come from CustomFormField.
   Trigger border / focus / error / disabled come from .cui-control. */

.cdd-row {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
}

/* ---------- trigger ---------- */

.cdd-searchWrap {
  position: relative;
  flex: 1 1;
  min-width: 0;
  width: 100%;
}

.cui-control.cdd-searchTrigger { /* paired with .cui-control: wins regardless of CSS load order */
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  text-align: left;
  cursor: pointer;
}

.cdd-searchTriggerLabel {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cdd-placeholder {
  color: var(--cui-text-placeholder);
}

.cdd-chevron {
  width: 15px;
  height: 15px;
  flex-shrink: 0;
  fill: none;
  stroke: var(--cui-text-muted);
  stroke-width: 2.2;
  stroke-linecap: round;
  stroke-linejoin: round;
  transition: transform var(--cui-transition), stroke var(--cui-transition);
}

.cdd-chevron-open {
  transform: rotate(180deg);
  stroke: var(--cui-primary);
}

.cui-control-error .cdd-chevron {
  stroke: var(--cui-danger);
}

/* ---------- menu (portal) ---------- */

.cdd-menu-portal {
  /* Menus must float above EVERY overlay they can be opened from:
     CustomModal (1300), table confirm dialog (3000), table filter drawer (4000) */
  z-index: 5000;
  background: var(--cui-bg);
  border: var(--cui-border-width) solid var(--cui-border);
  border-radius: 12px;
  box-shadow: 0 16px 32px -12px rgba(15, 23, 41, 0.22);
  overflow: hidden;
  animation: cdd-pop 0.12s ease both;
}

.cdd-menu-top {
  box-shadow: 0 -16px 32px -12px rgba(15, 23, 41, 0.22);
}

@keyframes cdd-pop {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.cdd-searchInput {
  width: 100%;
  padding: 10px 12px;
  font-size: var(--cui-font-size);
  border: none;
  border-bottom: 1px solid var(--cui-border-soft);
  outline: none;
  color: var(--cui-text);
  background: var(--cui-bg);
}

.cdd-optionsList {
  overflow-y: auto;
}

.cdd-option {
  padding: 10px 12px;
  font-size: var(--cui-font-size);
  color: var(--cui-text);
  cursor: pointer;
  transition: background 0.12s ease;
}

.cdd-option:hover,
.cdd-option-active {
  background: var(--cui-bg-hover);
}

/* keyboard highlight on the selected option stays visible */
.cdd-option-selected.cdd-option-active {
  box-shadow: inset 3px 0 0 var(--cui-primary);
}

.cdd-option-selected {
  background: var(--cui-primary-soft);
  font-weight: 600;
  color: var(--cui-primary);
}

.cdd-noResults {
  padding: 14px 12px;
  font-size: var(--cui-font-size);
  color: var(--cui-text-placeholder);
  text-align: center;
}

/* ---------- clear button (same height as the trigger) ---------- */

.cdd-clearBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: var(--cui-control-height);
  height: var(--cui-control-height);
  padding: 0;
  border: var(--cui-border-width) solid var(--cui-danger-border);
  border-radius: var(--cui-radius);
  background: var(--cui-danger-soft);
  color: var(--cui-danger);
  cursor: pointer;
  transition: background var(--cui-transition), border-color var(--cui-transition);
}

.cdd-clearBtn:hover:not(:disabled) {
  background: var(--cui-danger-soft-hover);
  border-color: var(--cui-danger);
}

.cdd-clearBtn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--cui-danger-ring);
}

.cdd-clearBtn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Old prop-less required marker (no label passed) */
.cdd-required {
  margin-left: 3px;
  color: var(--cui-danger);
}
`, "",{"version":3,"sources":["webpack://./src/Component/CustomDropdowns/CustomDropdowns.css"],"names":[],"mappings":"AAAA;sEACsE;;AAEtE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA,kCAAkC;;AAElC;EACE,kBAAkB;EAClB,SAAO;EACP,YAAY;EACZ,WAAW;AACb;;AAEA,iCAAiC,gEAAgE;EAC/F,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,UAAU;EACV,6BAA6B;EAC7B,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,yEAAyE;AAC3E;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wCAAwC;;AAExC;EACE;kFACgF;EAChF,aAAa;EACb,yBAAyB;EACzB,uDAAuD;EACvD,mBAAmB;EACnB,oDAAoD;EACpD,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;EACZ,+CAA+C;EAC/C,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,sBAAsB;EACtB,eAAe;EACf,iCAAiC;AACnC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA,4DAA4D;AAC5D;EACE,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA,oEAAoE;;AAEpE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gCAAgC;EAChC,iCAAiC;EACjC,UAAU;EACV,8DAA8D;EAC9D,gCAAgC;EAChC,kCAAkC;EAClC,wBAAwB;EACxB,eAAe;EACf,gFAAgF;AAClF;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,gBAAgB;EAChB,wBAAwB;AAC1B","sourcesContent":["/* Label, required \"*\", hint and error text come from CustomFormField.\n   Trigger border / focus / error / disabled come from .cui-control. */\n\n.cdd-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n}\n\n/* ---------- trigger ---------- */\n\n.cdd-searchWrap {\n  position: relative;\n  flex: 1;\n  min-width: 0;\n  width: 100%;\n}\n\n.cui-control.cdd-searchTrigger { /* paired with .cui-control: wins regardless of CSS load order */\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  text-align: left;\n  cursor: pointer;\n}\n\n.cdd-searchTriggerLabel {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cdd-placeholder {\n  color: var(--cui-text-placeholder);\n}\n\n.cdd-chevron {\n  width: 15px;\n  height: 15px;\n  flex-shrink: 0;\n  fill: none;\n  stroke: var(--cui-text-muted);\n  stroke-width: 2.2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  transition: transform var(--cui-transition), stroke var(--cui-transition);\n}\n\n.cdd-chevron-open {\n  transform: rotate(180deg);\n  stroke: var(--cui-primary);\n}\n\n.cui-control-error .cdd-chevron {\n  stroke: var(--cui-danger);\n}\n\n/* ---------- menu (portal) ---------- */\n\n.cdd-menu-portal {\n  /* Menus must float above EVERY overlay they can be opened from:\n     CustomModal (1300), table confirm dialog (3000), table filter drawer (4000) */\n  z-index: 5000;\n  background: var(--cui-bg);\n  border: var(--cui-border-width) solid var(--cui-border);\n  border-radius: 12px;\n  box-shadow: 0 16px 32px -12px rgba(15, 23, 41, 0.22);\n  overflow: hidden;\n  animation: cdd-pop 0.12s ease both;\n}\n\n.cdd-menu-top {\n  box-shadow: 0 -16px 32px -12px rgba(15, 23, 41, 0.22);\n}\n\n@keyframes cdd-pop {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.cdd-searchInput {\n  width: 100%;\n  padding: 10px 12px;\n  font-size: var(--cui-font-size);\n  border: none;\n  border-bottom: 1px solid var(--cui-border-soft);\n  outline: none;\n  color: var(--cui-text);\n  background: var(--cui-bg);\n}\n\n.cdd-optionsList {\n  overflow-y: auto;\n}\n\n.cdd-option {\n  padding: 10px 12px;\n  font-size: var(--cui-font-size);\n  color: var(--cui-text);\n  cursor: pointer;\n  transition: background 0.12s ease;\n}\n\n.cdd-option:hover,\n.cdd-option-active {\n  background: var(--cui-bg-hover);\n}\n\n/* keyboard highlight on the selected option stays visible */\n.cdd-option-selected.cdd-option-active {\n  box-shadow: inset 3px 0 0 var(--cui-primary);\n}\n\n.cdd-option-selected {\n  background: var(--cui-primary-soft);\n  font-weight: 600;\n  color: var(--cui-primary);\n}\n\n.cdd-noResults {\n  padding: 14px 12px;\n  font-size: var(--cui-font-size);\n  color: var(--cui-text-placeholder);\n  text-align: center;\n}\n\n/* ---------- clear button (same height as the trigger) ---------- */\n\n.cdd-clearBtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: var(--cui-control-height);\n  height: var(--cui-control-height);\n  padding: 0;\n  border: var(--cui-border-width) solid var(--cui-danger-border);\n  border-radius: var(--cui-radius);\n  background: var(--cui-danger-soft);\n  color: var(--cui-danger);\n  cursor: pointer;\n  transition: background var(--cui-transition), border-color var(--cui-transition);\n}\n\n.cdd-clearBtn:hover:not(:disabled) {\n  background: var(--cui-danger-soft-hover);\n  border-color: var(--cui-danger);\n}\n\n.cdd-clearBtn:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 3px var(--cui-danger-ring);\n}\n\n.cdd-clearBtn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Old prop-less required marker (no label passed) */\n.cdd-required {\n  margin-left: 3px;\n  color: var(--cui-danger);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
